__turbopack_context__.v({
  "body": "home-cta-module__uBKVgW__body",
  "button": "home-cta-module__uBKVgW__button",
  "content": "home-cta-module__uBKVgW__content",
  "section": "home-cta-module__uBKVgW__section",
  "title": "home-cta-module__uBKVgW__title",
});
